<template>
  <div>
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      :actions="headerActions"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <filter-manager
      ref="filter"
      v-model="filter.model"
      :filters="filtersHeader"
      :display-advanced="false"
      class="filter-manager_extended"
      search-container-class="search-btn"
      @search="searchHandler()"
    />
    <div class="row my-3 mx-0">
      <div class="col-12">
        <custom-separator text="Resultados" />
      </div>
    </div>

    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />

    <section v-if="result" class="mt-4 mx-0">
      <result-row v-for="(item, index) in result" :key="index" :item="item" />
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </section>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import CustomSeparator from 'custom-separator';
import mixAlert from '@/mixins/alert.mixin';
import FilterManager from 'FilterManager';
import CustomResultNotFound from 'custom-result-not-found';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import digitizedFileService from '@/services/api/digitizedfile.api';
import ResultRow from './components/ResultRow.vue';
const MODULE_NAME = 'DigitizedFile';

export default {
  components: {
    FilterManager,
    PageHeader,
    Pagination,
    CustomSeparator,
    CustomResultNotFound,
    ResultRow,
  },
  mixins: [mixAlert, storeMixin],
  data: () => ({
    moduleName: MODULE_NAME,
    page: {
      icon: 'fas fa-list',
      title: 'Expediente Digitalizado',
      routes: ['Asistencia Tecnológica', 'Expediente Digitalizado'],
    },
    results: [],
    filter: {
      model: {
        academicYear: null,
        sie: null,
      },
      options: {
        academicYears: [],
      },
    },
    result: [],
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 10,
    },
  }),
  computed: {
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'at' }),
        },
      ];
    },
    filtersHeader() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filter.options.academicYears,
          value: this.filter.model.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: true,
          error: 'El año académico es requerido.',
          validations: 'required',
        },
        {
          name: 'sie',
          component: 'CustomInput',
          value: this.filter.model.sie,
          placeholder: 'Escriba Número de Referido o Número de SIE',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md-9',
          type: 'text',
        },
      ];
    },
    showNotResults() {
      return this.result.length == 0;
    },
  },
  async mounted() {
    await Promise.all([this.getAcademicYears()]);
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getAcademicYears() {
      const {
        data: academicYearsList,
      } = await digitizedFileService.getAcademicyears();
      this.filter.options.academicYears = academicYearsList;
      this.filter.model.academicYear = academicYearsList.find(
        (x) => x.selected
      );
    },
    async onPageChange(page, validate = true) {
      this.search(this.filter.model, page, validate);
      this.activeIndex = null;
    },
    async search(filters, page = 1, validate = true) {
      const isValid = validate
        ? await this.$refs.filter.$refs.formValidator.validate()
        : true;
      if (!isValid) return;

      try {
        const { academicYear, sie } = filters;

        const payload = {
          academicYearId: (academicYear || {}).id,
          referralNumberOrSieId: sie,
          currentPage: page,
          pageSize: 10,
        };

        const { data } = await digitizedFileService.search(payload);
        this.result = data.data;

        this.pagination = {
          ...this.pagination,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        };
      } catch (error) {
        this.ShowToast(error.message, '', 'error');
      }
    },
    async searchHandler() {
      await this.search(this.filter.model);
      this.activeIndex = null;
    },
  },
  beforeRouteEnter(_, from, next) {
    const routes = [];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1, false);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.search-btn {
  width: 100px;
}
</style>
